module.exports = __webpack_public_path__ + "static/media/experientialEventStandAlone.9581fd97.jpg";